export default __webpack_public_path__ + "static/media/badgeO.69bd8e33.png";